import { moduleFactory } from "@/factories/module";
import { clientEnvBuildInfo } from "@/modules/client-env/buildInfo";
import {
  clearClientEnvClientGroupId,
  clientEnvClientGroupId,
} from "@/modules/client-env/clientGroupId";
import { clearClientEnvClientId, clientEnvClientId } from "@/modules/client-env/clientId";
import { clientEnvGetElectricBaseUrl } from "@/modules/client-env/electric";
import { clientEnvIsDesktop } from "@/modules/client-env/isDesktop";
import {
  clientEnvNodeEnvironment,
  clientEnvNodeEnvironmentIsDev,
  clientEnvNodeEnvironmentIsProd,
  clientEnvNodeEnvironmentIsTest,
} from "@/modules/client-env/nodeEnvironment";
import { clientEnvPackageVersion } from "@/modules/client-env/packageVersion";
import { clientEnvPlatformKind } from "@/modules/client-env/platformKind";
import { clientEnvPosthogProjectApiKey } from "@/modules/client-env/posthogConfig";
import { clientEnvGoogleAnalyticsMeasurementId } from "@/modules/client-env/measurementIds";
import { clientEnvStripeConfig } from "@/modules/client-env/stripeConfig";
import { clientEnvLocalBackendApiIsEnabled } from "@/modules/client-env/viteConfig";
import { clientEnvIsWindows } from "@/modules/client-env/isWindows";
import { clientEnvIsWindowsBrowser } from "@/modules/client-env/isWindowsBrowser";
import { clientEnvIsMacOs } from "@/modules/client-env/isMacOs";
import { clientEnvIsMacBrowser } from "@/modules/client-env/isMacBrowser";
import { clientEnvIsLinux } from "@/modules/client-env/isLinux";
import { clientEnvIsLinuxBrowser } from "@/modules/client-env/isLinuxBrowser";
import { clientEnvIsIOS } from "@/modules/client-env/isIOS";
import { clientEnvIsIOSBrowser } from "@/modules/client-env/isIOSBrowser";
import { clientEnvIsAndroid } from "@/modules/client-env/isAndroid";
import { clientEnvIsAndroidBrowser } from "@/modules/client-env/isAndroidBrowser";
import { clientEnvAgentInfo } from "@/modules/client-env/browserInfo";
import { clientEnvIsMobile } from "@/modules/client-env/isMobile";
import { clientEnvIsMobileBrowser } from "@/modules/client-env/isMobileBrowser";

export const clientEnvModule = moduleFactory.create({
  nodeEnv: clientEnvNodeEnvironment,
  isProd: clientEnvNodeEnvironmentIsProd,
  isDev: clientEnvNodeEnvironmentIsDev,
  isTest: clientEnvNodeEnvironmentIsTest,
  localBackendApiIsEnabled: clientEnvLocalBackendApiIsEnabled,
  clientId: clientEnvClientId,
  clientGroupId: clientEnvClientGroupId,
  stripe: clientEnvStripeConfig,
  buildInfo: clientEnvBuildInfo,
  packageVersion: clientEnvPackageVersion,
  isDesktop: clientEnvIsDesktop,
  clearClientId: clearClientEnvClientId,
  clearClientGroupId: clearClientEnvClientGroupId,
  platformKind: clientEnvPlatformKind,
  posthogProjectApiKey: clientEnvPosthogProjectApiKey,
  googleAnalyticsMeasurementId: clientEnvGoogleAnalyticsMeasurementId,
  getElectricBaseUrl: clientEnvGetElectricBaseUrl,
  // the following helpers are powered by Bowser (see internal impl for details)
  isWindows: clientEnvIsWindows,
  isWindowsBrowser: clientEnvIsWindowsBrowser,
  isMacOs: clientEnvIsMacOs,
  isMacBrowser: clientEnvIsMacBrowser,
  isLinux: clientEnvIsLinux,
  isLinuxBrowser: clientEnvIsLinuxBrowser,
  isIos: clientEnvIsIOS,
  isIosBrowser: clientEnvIsIOSBrowser,
  isAndroid: clientEnvIsAndroid,
  isAndroidBrowser: clientEnvIsAndroidBrowser,
  isMobile: clientEnvIsMobile,
  isMobileBrowser: clientEnvIsMobileBrowser,
  agentInfo: clientEnvAgentInfo,
});
